import { observer } from 'mobx-react';
import React, { FC, useEffect } from 'react';
import { FranchiseProfileBranches } from './containers/FranchiseProfileBranches/FranchiseProfileBranches';
import { FranchiseProfiles } from './containers/FranchiseProfiles/FranchiseProfiles';
import { FranchiseProfileSettings } from './containers/FranchiseProfileSettings/FranchiseProfileSettings';
import { franchiseManagementStore } from './store/franchiseManagementStore';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import { LoadingStatus } from '~/types/main';
import { leaveWithoutSaving } from '~/utils/modalConfirmations';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from '~/view/containers/Headers/Headers';
import { appStore } from '~/mobx/appStore';

const FranchiseManagement: FC = observer((): JSX.Element => {
  useEffect(() => {
    franchiseManagementStore.fetchFranchisesList();
    return () => franchiseManagementStore.reset();
  }, []);

  const handleBackClick = () => {
    if (franchiseManagementStore.isDataEdited) {
      leaveWithoutSaving({ onConfirm: () => history.push(SCREENS.SETTINGS()) });
    } else {
      history.push(SCREENS.SETTINGS());
    }
  };

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('franchise_management')} path={SCREENS.SETTINGS()} callback={handleBackClick} />
      </Headers>
      {appStore.settings?.is_pos ? (
        <p
          className="family-regular text-size-16 mt-6"
          style={{
            background: '#FFD130',
            height: 35,
            borderRadius: 12,
            padding: '8px 15px 8px 15px',
            width: 'fit-content',
          }}
        >
          {localeStore.t('default_POS')}
        </p>
      ) : null}
      <div className="d-flex flex-1 mt-6">
        <FranchiseProfiles />
        <FranchiseProfileBranches />
        <FranchiseProfileSettings />
      </div>
      <LoadingOverlay visible={[LoadingStatus.Loading, LoadingStatus.Refreshing].includes(franchiseManagementStore.loadingStatus)} refreshing />
    </div>
  );
});

export default FranchiseManagement;
